export default "__VITE_ASSET__BFKTg0_M__"